import { render, staticRenderFns } from "./DefaulterOnGoingSchemes.vue?vue&type=template&id=7b303bf7"
import script from "./DefaulterOnGoingSchemes.vue?vue&type=script&lang=js"
export * from "./DefaulterOnGoingSchemes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports